<template>
  <div>
    <b-container class="fp-container bg-light-grey" fluid>
      <b-container class="mt-5">
        <b-row>
          <b-col md="4" class="text-left pb-5">
            <router-link to="/hanke" class="button-orange">
              <font-awesome-icon icon="arrow-circle-left" class="icon"></font-awesome-icon> Palaa edelliseen
            </router-link>
          </b-col>
          <b-col md="8">
            <h1>Selvitä kohteen palomääräykset</h1>
          </b-col>
        </b-row>
      </b-container>
      <Paloluokka v-on:changed="onSelectionChanged" />
      <Maaraykset v-show="userSelection.results.p1 || userSelection.results.p2 || userSelection.results.p3" ref="mtable" />
    </b-container>
    <b-container class="fp-container" v-show="userSelection.results.p1 || userSelection.results.p2 || userSelection.results.p3" >
      <b-row>
        <b-col md="12" class="text-right">
          <router-link to="/jarjestelmat" class="button-orange">
            <font-awesome-icon icon="arrow-circle-right" class="icon"></font-awesome-icon> Seuraava
          </router-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Paloluokka from '../components/Paloluokka'
import Maaraykset from '../components/Maaraykset'

export default {
  name: 'Aloitus',
  components: {Paloluokka, Maaraykset},
  data () {
    return {
    }
  },
  methods: {
    onSelectionChanged () {
      this.$refs.mtable.updatePintaluokat()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Selvitys.vue